import { useEffect } from 'react';
import { useAuth } from '../hooks/useAuth';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { RememberMePrompt } from './RememberMePrompt';
import { CenteredLayout } from '@/components/layout/CenteredLayout';
import { Button } from '@/components/ui/button';

export function VerifyPage() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { verify, session } = useAuth();
  const token = searchParams.get('token');

  useEffect(() => {
    if (!token) {
      navigate('/', { replace: true });
    }
  }, [token, navigate]);

  const handleSubmit = async (rememberMe: boolean) => {
    if (!token) return;

    try {
      await verify(token, rememberMe);
      navigate('/', { replace: true });
    } catch {
      // Error will be shown in the session state
      navigate('/', { replace: true });
    }
  };

  if (session.error) {
    return (
      <CenteredLayout
        title="Verification Failed"
        subtitle={session.error}
      >
        <Button
          onClick={() => navigate('/')}
          className="mt-4 block mx-auto w-full lg:w-72"
        >
          Return to Login
        </Button>
      </CenteredLayout>
    );
  }

  return (
    <CenteredLayout
      title="Sign in to Promo"
      subtitle="Your magic link is ready to verify"
    >
      <RememberMePrompt 
        onSubmit={handleSubmit}
        isLoading={session.isLoading}
        showTitle={false}
        token={token || undefined}
      />
    </CenteredLayout>
  );
} 